import { ReactNode } from 'react';
import { BoxProps, List } from '@chakra-ui/react';
import { Colors } from '@mercator-gcp/grout';

const sectionItemListStyle = {
  display: 'flex',
  flexDirection: 'column',
  '>div': {
    borderTop: `1px solid ${Colors.ArmyGreen900}`,
  },
  '>div:last-child': {
    borderBottom: `1px solid ${Colors.ArmyGreen900}`,
  },
};

type TSectionDropdownListProps = {
  children: ReactNode;
  sx?: BoxProps['sx'];
};

const SectionDropdownList = ({ children, sx }: TSectionDropdownListProps) => {
  return <List sx={{ ...sectionItemListStyle, ...sx }}>{children}</List>;
};

export default SectionDropdownList;
